
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMonitoringRoute as ObiMonitoringRouteElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-monitoring-route.js';
 
 
 

 
 export const ObiMonitoringRoute = createComponent({
   react: React,
   tagName: 'obi-monitoring-route',
   elementClass: ObiMonitoringRouteElement,
   events: {
     
   }
  });
 
 